import React from 'react';
import { Button, Text, VStack } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
import { localise } from '../../../services/lang/lang';
import { makeReg4 } from '../../../styles/textStyles';
import ImageIcon from '../../icons/ImageIcon/ImageIcon';
const AddPhotoButton = (props) => {
    const tokens = useTokens();
    return (React.createElement(Button, { padding: tokens.Spacing04, width: "106px", height: "106px", variant: "secondary", "data-testid": "add_photo_button", "aria-label": localise('ADD_PHOTO'), borderRadius: tokens.BorderRadius02, border: `${tokens.BorderWidth01} dashed ${tokens.BorderLight500}`, ...props },
        React.createElement(VStack, null,
            React.createElement(ImageIcon, null),
            React.createElement(Text, { "data-testid": "add_photo_button__text", sx: makeReg4(tokens, {
                    color: tokens.IconPrimary,
                    textDecoration: 'underline',
                }), textAlign: "center" }, localise('ADD_PHOTO')))));
};
export default AddPhotoButton;
